// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2n-q";
export var animationRelative = "_2n-p";
export var backdropBlur = "_2n-0";
export var detailLabelCell = "_2n-12";
export var detailTable = "_2n-11";
export var detailValueCell = "_2n-13";
export var docIconBox = "_2n-1d";
export var docIconBoxMd = "_2n-1f";
export var docIconBoxSm = "_2n-1e";
export var docTypeRow = "_2n-16";
export var docTypeRowInner = "_2n-17";
export var dropdownMatchDatePicker = "_2n-3";
export var evidenceCardContent = "_2n-1c";
export var fileUploadSpin = "_2n-j";
export var gorgiasOpenButton = "_2n-15 _2n-d";
export var gorgiasTicketCard = "_2n-14";
export var heroModalFooterButton = "_2n-18";
export var hiddenContainer = "_2n-o";
export var iconPrimary = "_2n-1g";
export var iconSecondary = "_2n-1h";
export var iconTertiary = "_2n-1i";
export var integrationCard = "_2n-1";
export var integrationLogoBox = "_2n-2";
export var mainColumnSticky = "_2n-1b";
export var maxWidthContainer = "_2n-19";
export var modalContentBody = "_2n-a";
export var modalHeaderImage = "_2n-5";
export var modalImageLabel = "_2n-7";
export var modalImageOverlay = "_2n-6";
export var modalImageSubtitle = "_2n-9";
export var modalImageTitle = "_2n-8";
export var modalImageWrapper = "_2n-4";
export var modalStickyFooter = "_2n-b";
export var removeButton = "_2n-e";
export var sidebarColumn = "_2n-1a";
export var spinner = "_2n-i";
export var timelineLine = "_2n-y";
export var timelineLineBlack = "_2n-10 _2n-y";
export var timelineLineGray = "_2n-z _2n-y";
export var timelineLineHeight = "_2n-x";
export var tlDotActivate = "_2n-u";
export var tlDotActivateAnim = "_2n-t";
export var tlDotHide = "_2n-s";
export var tlDotHideAnim = "_2n-r";
export var tlLineActivate = "_2n-w";
export var tlLineActivateAnim = "_2n-v";
export var uploadHint = "_2n-n";
export var uploadIconBox = "_2n-k";
export var uploadLabel = "_2n-m";
export var uploadText = "_2n-l";
export var uploadZone = "_2n-f";
export var uploadZoneCursorDefault = "_2n-h";
export var uploadZoneCursorPointer = "_2n-g";
export var uploadedFileRow = "_2n-c";
export var viewButton = "_2n-d";